// extracted by mini-css-extract-plugin
module.exports = {"container":"EditModale_container__3dRuw"};